export default "__VITE_ASSET__BNYtOE6O__"